import {FC, useEffect, useRef} from 'react';
import * as Styles from './panelItem.styles';
import CheckIcon from './checkIcon.svg';

export const PanelItem: FC<PanelItemProps> = ({
  ariaLabel,
  focused,
  label,
  isSelected,
  onClick,
}) => {
  const ref = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    const $container = ref.current;

    if (!$container) return;

    if (focused) {
      $container.focus();
    } else {
      $container.blur();
    }
  }, [focused]);

  return (
    <Styles.Container
      aria-label={ariaLabel}
      aria-pressed={isSelected}
      onClick={onClick}
      ref={ref}
    >
      {label}
      <Styles.Check>
        {isSelected && <CheckIcon data-testid="panelitem-checkbox" />}
      </Styles.Check>
    </Styles.Container>
  );
};

export interface PanelItemProps {
  ariaLabel: string;
  focused?: boolean;
  label: string;
  isSelected: boolean;
  onClick: () => void;
}
